import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/app/global-error.tsx");
